(function () {
  class QRGenerator {
    constructor(sectionElement) {
      this.sectionElement = sectionElement;
      this.sectionId = sectionElement.dataset.sectionId;

      // DOM elements
      this.qrContainer = document.getElementById('qr-code-' + this.sectionId);
      this.fallbackContainer = document.getElementById('fallback-' + this.sectionId);
      this.redirectMessage = document.getElementById('redirect-message-' + this.sectionId);
      this.countrySelect = document.getElementById('country-select-' + this.sectionId);

      // Configuration
      this.config = {
        qrSize: parseInt(sectionElement.dataset.qrSize),
        autoRedirect: sectionElement.dataset.autoRedirect === 'true',
        redirectDelay: parseInt(sectionElement.dataset.redirectDelay),
        qrColor: sectionElement.dataset.qrColor,
        qrBgColor: sectionElement.dataset.qrBgColor,
        textColor: sectionElement.dataset.textColor,
        clickText: sectionElement.dataset.clickText || 'or',
        clickLinkText: sectionElement.dataset.clickLinkText || 'click here',
        isEditor: sectionElement.dataset.isEditor === 'true',
      };

      // Parse and map store data
      this.storeMap = this.parseStores();

      // Initialize
      this.init();
    }

    parseStores() {
      try {
        const rawStores = JSON.parse(this.sectionElement.dataset.stores || '[]');

        return rawStores.map((settings) => {
          let hostname = '';
          try {
            const url = new URL(settings.return_url);
            hostname = url.hostname;
          } catch (e) {
            // Invalid URL, skip hostname
          }

          return {
            storeName: settings.store_name,
            returnUrl: settings.return_url,
            codes: settings.country_codes
              .split(',')
              .map((c) => c.trim().toUpperCase())
              .filter((c) => c.length > 0),
            hostname: hostname,
          };
        });
      } catch (e) {
        return [];
      }
    }

    findStoreByCountry(countryCode) {
      return this.storeMap.find((store) => store.codes.includes(countryCode.toUpperCase()));
    }

    isOnCorrectHostname(store) {
      if (!store.hostname) return false;
      return window.location.hostname === store.hostname;
    }

    generateQRCode(url, container) {
      if (typeof QRCode === 'undefined') {
        setTimeout(() => this.generateQRCode(url, container), 100);
        return;
      }

      container.innerHTML = '';

      const qrWrapper = document.createElement('div');
      qrWrapper.className = 'qr-generator__qr-canvas';
      qrWrapper.id = 'qr-wrapper-' + this.sectionId;
      container.appendChild(qrWrapper);

      try {
        new QRCode(qrWrapper, {
          text: url,
          width: this.config.qrSize,
          height: this.config.qrSize,
          colorDark: this.config.qrColor,
          colorLight: this.config.qrBgColor,
          correctLevel: QRCode.CorrectLevel.H,
        });

        const clickLink = document.createElement('p');
        clickLink.style.display = 'block';
        clickLink.style.marginTop = '16px';
        clickLink.style.color = this.config.textColor;
        clickLink.style.textAlign = 'center';
        clickLink.innerHTML =
          this.config.clickText +
          ' <a href="' +
          url +
          '" style="color: ' +
          this.config.textColor +
          ';">' +
          this.config.clickLinkText +
          '</a>';
        container.appendChild(clickLink);
      } catch (error) {
        container.innerHTML = '<p style="color: red;">Error generating QR code</p>';
      }
    }

    showFallback() {
      if (this.qrContainer) {
        this.qrContainer.style.display = 'none';
      }
      if (this.fallbackContainer) {
        this.fallbackContainer.style.display = 'block';
      }
    }

    redirectToStore(url) {
      // Skip auto-redirect if in theme editor
      if (this.config.autoRedirect && !this.config.isEditor) {
        if (this.redirectMessage) {
          this.redirectMessage.style.display = 'block';
        }
        if (this.fallbackContainer) {
          this.fallbackContainer.style.display = 'none';
        }
        if (this.qrContainer) {
          this.qrContainer.style.display = 'none';
        }

        setTimeout(() => {
          window.location.href = url;
        }, this.config.redirectDelay);
      } else {
        if (this.qrContainer) {
          this.generateQRCode(url, this.qrContainer);
        }
      }
    }

    setupEventListeners() {
      if (this.countrySelect) {
        this.countrySelect.addEventListener('change', () => {
          const selectedUrl = this.countrySelect.value;

          if (selectedUrl) {
            if (this.qrContainer) {
              this.qrContainer.style.display = 'flex';
            }
            this.redirectToStore(selectedUrl);
          }
        });
      }
    }

    attemptAutoDetection() {
      fetch('/browsing_context_suggestions.json')
        .then((r) => r.json())
        .then((data) => {
          if (data.detected_values && data.detected_values.country) {
            const countryCode = data.detected_values.country.handle;
            const store = this.findStoreByCountry(countryCode);

            if (store) {
              if (this.isOnCorrectHostname(store) && !this.config.autoRedirect) {
                if (this.qrContainer) {
                  this.generateQRCode(store.returnUrl, this.qrContainer);
                }
              } else {
                this.redirectToStore(store.returnUrl);
              }
            } else {
              this.showFallback();
            }
          } else {
            this.showFallback();
          }
        })
        .catch(() => {
          this.showFallback();
        });
    }

    init() {
      if (!this.qrContainer && !this.fallbackContainer) {
        return;
      }

      if (this.storeMap.length === 0) {
        this.showFallback();
        return;
      }

      this.setupEventListeners();
      this.attemptAutoDetection();
    }
  }

  function initAllQRGenerators() {
    const sections = document.querySelectorAll('.qr-generator-section');
    sections.forEach((section) => {
      new QRGenerator(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllQRGenerators);
  } else {
    initAllQRGenerators();
  }
  console.log('QRGenerator initialized', Shopify.designMode);

  window.QRGenerator = QRGenerator;
})();
